// extracted by mini-css-extract-plugin
var _1 = "UoQW21_pJW5C8vylvMc9";
var _2 = "I2CS3a6c4Iodtpeid0i8";
export { _1 as "canvasWrapper", _2 as "fileTrigger" }
